/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */





// Import our default css theme for splide


// This should only be output on the frontend of the site - NOT the editor

document.addEventListener('DOMContentLoaded', () => {

  const prevArrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="55.848" height="55.848" viewBox="0 0 27.924 27.924">
      <g id="Grupo_15709" data-name="Grupo 15709" transform="translate(-278 -254.938)">
        <g id="Grupo_14564" data-name="Grupo 14564" transform="translate(98 -473.063)">
          <g id="Grupo_14490" data-name="Grupo 14490" transform="translate(15646.576 -10419)">
            <rect id="Rectángulo_140" data-name="Rectángulo 140" width="27.924" height="27.924" transform="translate(-15466.576 11147)" fill="none"/>
          </g>
        </g>
        <g id="Grupo_15708" data-name="Grupo 15708" transform="translate(282.981 264.26)">
          <path id="Línea_15" data-name="Línea 15" d="M9.59,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H9.59a1,1,0,0,1,1,1A1,1,0,0,1,9.59,1Z" transform="translate(8.057 4.64)"/>
          <path id="Línea_18" data-name="Línea 18" d="M2.524,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H2.524a1,1,0,0,1,1,1A1,1,0,0,1,2.524,1Z" transform="translate(3.019 4.64)"/>
          <path id="Línea_19" data-name="Línea 19" d="M.5,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H.5a1,1,0,0,1,1,1A1,1,0,0,1,.5,1Z" transform="translate(0 4.64)"/>
          <path id="Línea_16" data-name="Línea 16" d="M6.561,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H6.561a1,1,0,0,1,1,1A1,1,0,0,1,6.561,1Z" transform="translate(13.007 0) rotate(45)"/>
          <path id="Línea_17" data-name="Línea 17" d="M0,1A1,1,0,0,1-1,0,1,1,0,0,1,0-1H6.561a1,1,0,0,1,1,1,1,1,0,0,1-1,1Z" transform="translate(17.646 4.64) rotate(135)"/>
        </g>
      </g>
    </svg>`;

  const nextArrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="55.848" height="55.848" viewBox="0 0 27.924 27.924">
      <g id="Grupo_15709" data-name="Grupo 15709" transform="translate(-278 -254.938)">
        <g id="Grupo_14564" data-name="Grupo 14564" transform="translate(98 -473.063)">
          <g id="Grupo_14490" data-name="Grupo 14490" transform="translate(15646.576 -10419)">
            <rect id="Rectángulo_140" data-name="Rectángulo 140" width="27.924" height="27.924" transform="translate(-15466.576 11147)" fill="none"/>
          </g>
        </g>
        <g id="Grupo_15708" data-name="Grupo 15708" transform="translate(282.981 264.26)">
          <path id="Línea_15" data-name="Línea 15" d="M9.59,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H9.59a1,1,0,0,1,1,1A1,1,0,0,1,9.59,1Z" transform="translate(8.057 4.64)"/>
          <path id="Línea_18" data-name="Línea 18" d="M2.524,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H2.524a1,1,0,0,1,1,1A1,1,0,0,1,2.524,1Z" transform="translate(3.019 4.64)"/>
          <path id="Línea_19" data-name="Línea 19" d="M.5,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H.5a1,1,0,0,1,1,1A1,1,0,0,1,.5,1Z" transform="translate(0 4.64)"/>
          <path id="Línea_16" data-name="Línea 16" d="M6.561,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H6.561a1,1,0,0,1,1,1A1,1,0,0,1,6.561,1Z" transform="translate(13.007 0) rotate(45)"/>
          <path id="Línea_17" data-name="Línea 17" d="M0,1A1,1,0,0,1-1,0,1,1,0,0,1,0-1H6.561a1,1,0,0,1,1,1,1,1,0,0,1-1,1Z" transform="translate(17.646 4.64) rotate(135)"/>
        </g>
      </g>
    </svg>`;

  const splides = document.querySelectorAll('.image-carousel')
  if (!!splides && splides.length > 0) {
    splides.forEach(splide => {
      
      // const splide = document.getElementById('image-carosuel-splide')
      const interval = parseInt(splide.dataset.interval) * 1000 || 3000;
      const isAutoplay = splide.dataset.autoplay === "true";
      const isPauseOnHover = splide.dataset.pauseonhover === "true";
      const imagesPerSlideMob = parseInt(splide.dataset.imagesperslidemob);
      const imagesPerSlideTab = parseInt(splide.dataset.imagesperslidetab);
      const imagesPerSlideDesk = parseInt(splide.dataset.imagesperslidedesk);
      const arrowClass = splide.dataset.arrows;
      
      const breakpoints = {
        // Mobile View (up to 640px)
        640: {
          perPage: imagesPerSlideMob,  // Show only one slide on screens below 640px
        },
        // Tablet View (between 640px and 1024px)
        1024: {
          perPage: imagesPerSlideTab,  // Show two slides on screens between 640px and 1024px
        },
        // Desktop View (above 1024px)
        2560: {  // "inf" represents infinity, targeting screens larger than 1024px
          perPage: imagesPerSlideDesk,  // Show three slides on desktops
        }
      };

      new Splide(splide, {
        role: 'group',
        classes: {
          prev  : 'splide__arrow--prev prev-'+arrowClass,
          next  : 'splide__arrow--next next-'+arrowClass,
        }, type: 'loop', autoplay: isAutoplay, perPage: 3, pauseOnHover: isPauseOnHover, interval: interval, breakpoints: breakpoints,
        gap: '1em',
        
       
      }).mount();
      if(arrowClass=='chevron-icon'){
        const updateArrows = () => {
          splide.querySelectorAll('.splide__arrow--prev').forEach(arrow => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(prevArrowSvg, 'image/svg+xml');
            arrow.innerHTML = '';
            arrow.appendChild(doc.documentElement);
          });
          splide.querySelectorAll('.splide__arrow--next').forEach(arrow => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(nextArrowSvg, 'image/svg+xml');
            arrow.innerHTML = '';
            arrow.appendChild(doc.documentElement);
          });
        };
        
        updateArrows();
        window.addEventListener('resize', () => setTimeout(updateArrows, 320));
      }
      
     
      
     
      
    })

  }

})



